// extracted by mini-css-extract-plugin
export default {"dialog":"store-notification_dialog__jG7cv","stores":"store-notification_stores__4u5so","link":"store-notification_link__pOCab"};